export interface State {
  current_page: number
  total_count: number
  detail: Array<any>
  params: CorpParams
}

export interface CorpParams {
  sort_column: string
  sort: string
  page_size: number
  page_number: number
}

const state = (): State => ({
  current_page: 0,
  total_count: 0,
  detail: [],
  params: {
    sort_column: 'corporate_katakana',
    sort: 'ASC',
    page_size: 20,
    page_number: 1,
  },
})

export default state
